module.exports = __webpack_public_path__ + "img/battle_1.9de72d2f.png";